import { AgentChatPanel } from "@components/panels/agent-runner/AgentChatPanel"

import { PayloadBuilderProvider } from "@plugins/agent-runner/PayloadBuilder"
import { AgentHistoryProvider } from "@plugins/providers/agent/AgentHistoryProvider"
import { AvailableAgentProvider } from "@plugins/providers/agent/AvailableAgentProvider"
import { AvailableModelProvider } from "@plugins/providers/model/AvailableModelProvider"

export function ChatPage() {
    return (
        <AvailableAgentProvider>
            <AgentHistoryProvider>
                <AvailableModelProvider>
                    <PayloadBuilderProvider>
                        <AgentChatPanel />
                    </PayloadBuilderProvider>
                </AvailableModelProvider>
            </AgentHistoryProvider>
        </AvailableAgentProvider>
    )
}
